var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3512_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 16,
    rx: 2.5,
    fill: "white",
    stroke: "#8392B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4475 5.1358C11.3241 5.06702 11.1884 5.02328 11.0481 5.00708C10.9078 4.99088 10.7657 5.00254 10.63 5.0414C10.4942 5.08025 10.3674 5.14554 10.2568 5.23352C10.1463 5.3215 10.0541 5.43045 9.98562 5.55414L7.9901 9.15181L6.84803 8.00768C6.74888 7.90484 6.63027 7.8228 6.49913 7.76637C6.36799 7.70993 6.22695 7.68023 6.08422 7.67898C5.9415 7.67774 5.79996 7.70499 5.66786 7.75913C5.53576 7.81327 5.41575 7.89323 5.31483 7.99434C5.2139 8.09544 5.13409 8.21567 5.08004 8.34801C5.026 8.48035 4.9988 8.62214 5.00004 8.76512C5.00128 8.9081 5.03093 9.0494 5.08727 9.18078C5.1436 9.31215 5.22549 9.43098 5.32815 9.53031L7.47791 11.684C7.68107 11.888 7.95516 12 8.23786 12L8.38673 11.9892C8.55148 11.9661 8.70864 11.9051 8.84582 11.8108C8.98301 11.7165 9.09648 11.5916 9.1773 11.446L11.8645 6.60028C11.9331 6.47669 11.9768 6.34077 11.9929 6.20028C12.0091 6.05979 11.9975 5.91749 11.9588 5.7815C11.92 5.64551 11.8549 5.5185 11.7672 5.40771C11.6795 5.29691 11.5708 5.20452 11.4475 5.1358Z",
    fill: "#8392B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3512_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickmark);
export default __webpack_public_path__ + "static/media/tickmark.50420b038c03cdbe95713370a89af8b5.svg";
export { ForwardRef as ReactComponent };